import { has } from 'lodash'
import { BaseOutput } from './base-output.model'

export interface SendOtpForAccountMatchingOutput extends BaseOutput {
  /* eslint-disable @typescript-eslint/naming-convention */
  DateTimeNextRequestIsAvailable: string
  MobilePrefix: string | null
  MobilePhone: string | null
  Email: string | null
  /* eslint-enable @typescript-eslint/naming-convention */
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isSendOtpForAccountMatchingOutput = (obj: any): obj is SendOtpForAccountMatchingOutput => {
  const dateTimeNextRequestIsAvailable = 'DateTimeNextRequestIsAvailable'
  const mobilePrefix = 'MobilePrefix'
  const mobilePhone = 'MobilePhone'
  const email = 'Email'

  return has(obj, dateTimeNextRequestIsAvailable) && has(obj, mobilePrefix) && has(obj, mobilePhone) && has(obj, email)
}
